// https://github.com/welldone-software/why-did-you-render#options
// uncomment the line below to enable why-did-you-render (for development only)
// import "../why-did-you-render"
import { ChakraProvider } from '@chakra-ui/react'
import { createRoot } from "react-dom/client"
import { App } from "./components/app"
import { kCodapAppElementId } from "./components/constants"
import { theme } from "./theme"

// starts the feature-flag config fetch at module load, so it races the document
// load rather than waiting for React to mount
import "./models/feature-flags/start-feature-flag-load"

import "./index.scss"

// Log the launch URL so testers can confirm where CODAP landed after any redirects.
// eslint-disable-next-line no-console
console.log(`CODAP launched at ${window.location.hostname}${window.location.pathname}${window.location.search}`)

// https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-client-rendering-apis
const container = document.getElementById(kCodapAppElementId)
const root = createRoot(container!)
root.render(
  <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>
)
